/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanerrorfailed3Inputs */

const en_menuscanerrorfailed3 = /** @type {(inputs: Menuscanerrorfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The menu could not be read. Try a sharper photo or enter it yourself.`)
};

const de_menuscanerrorfailed3 = /** @type {(inputs: Menuscanerrorfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Menü ließ sich nicht lesen. Versuch ein schärferes Foto oder trag es selbst ein.`)
};

/**
* | output |
* | --- |
* | "The menu could not be read. Try a sharper photo or enter it yourself." |
*
* @param {Menuscanerrorfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanerrorfailed3 = /** @type {((inputs?: Menuscanerrorfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanerrorfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanerrorfailed3(inputs)
	return de_menuscanerrorfailed3(inputs)
});
export { menuscanerrorfailed3 as "menuScanErrorFailed" }